import React, { Component } from 'react'
import { Tooltip, Select, MenuItem, FormControl } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/pro-duotone-svg-icons/faPenToSquare'
import MultiUpdateContentDossier from '@/feature/ContentDossier/Create/MultiUpdateContentDossier'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
class MultiContentDossierMassUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateDefDossierForm: false,
            overwrite: false,
        }

        this.handleClose = this.handleClose.bind(this)
        this.handleOnChange = this.handleOnChange.bind(this)
    }

    handleClose() {
        this.setState({ updateDefDossierForm: false })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    handleOnChange(e) {
        this.setState({ overwrite: e.target.value === 'true' })
    }

    overwrite() {
        const kedo = this.props.kedo
        return (
            <FormControl fullWidth size="small">
                <Select
                    size="small"
                    defaultValue="false"
                    onChange={(e) => this.handleOnChange(e)}
                >
                    <MenuItem value="false">
                        {kedo.t("Don't overwrite (Standard)")}
                    </MenuItem>
                    <MenuItem value="true">{kedo.t('Overwrite')}</MenuItem>
                </Select>
            </FormControl>
        )
    }

    formUpdate() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={kedo.t('Mass Update')}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        this.handleClose ? this.handleClose() : null
                    }
                }}
                headerClose={() => {
                    this.handleClose ? this.handleClose() : null
                }}
                contentProps={{ dividers: true }}
                key={`inline-modal-${this.props.dossierId}`}
            >
                <div>
                    <h6>{kedo.t('Options')}</h6>
                    <hr />
                    <p>{kedo.t('Fields that already have a value')}</p>
                    {this.overwrite()}
                    <MultiUpdateContentDossier
                        kedo={this.props.kedo}
                        props={{
                            multiUpdate: true,
                            overwrite: this.state.overwrite,
                            selectedDossierIds:
                                this.props.selectedDossierIds.map(
                                    (selectedIds) => selectedIds
                                ),
                            onClose: this.handleClose,
                        }}
                    />
                </div>
            </AppDialog>
        )
    }

    displayButton(onClick, button, tooltip = null) {
        if (!tooltip)
            return (
                <StyledButton
                    variant={'outlined'}
                    color="secondary"
                    onClick={onClick}
                >
                    {button}
                </StyledButton>
            )

        return (
            <Tooltip title={tooltip} placement="top">
                <StyledButton
                    variant={'outlined'}
                    color="secondary"
                    onClick={onClick}
                >
                    {button}
                </StyledButton>
            </Tooltip>
        )
    }

    render() {
        if (this.state.updateDefDossierForm || this.props.showModal) {
            return this.formUpdate()
        }

        const mode = this.props.mode
        return (
            <span>
                {this.displayButton(
                    () =>
                        this.setState({
                            updateDefDossierForm: true,
                        }),
                    <>
                        <FontAwesomeIcon icon={faPenToSquare} />{' '}
                        {mode &&
                        (mode === 'embeddedList' || mode === 'block') ? null : (
                            <>&nbsp; {this.props.kedo.t('Mass update')}</>
                        )}
                    </>,
                    mode && (mode === 'embeddedList' || mode === 'block')
                        ? this.props.kedo.t('Mass update')
                        : null
                )}
            </span>
        )
    }
}

export default MultiContentDossierMassUpdate
